export default __webpack_public_path__ + "static/media/logo-light.f37f74b3.png";